<template>
  <q-chip
    :color="quotationStatusColour(quotation.status)"
    text-color="white"
    class="chip text-center"
    dense
    :square="flat"
    style="width: 85px;"
  >
    {{ quotationStatusName(quotation.status) }}
  </q-chip>
</template>

<script>
import quotationMixin from './mixin'

export default {
  mixins: [quotationMixin],
  props: {
    quotation: {
      required: true,
      type: Object
    },
    flat: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.chip {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}
</style>
